// ===========================================
// HOOK: usePlanPagoForm
// ===========================================
// Hook TanStack Form para marcar plan de pago

import { useForm } from '@tanstack/react-form'
import { planPagoSchema, type PlanPagoFormValues } from './planPagoSchema'

interface UsePlanPagoFormOptions {
  onSubmit?: (value: PlanPagoFormValues) => Promise<void>
  defaultValues?: Partial<PlanPagoFormValues>
}

export function usePlanPagoForm(options: UsePlanPagoFormOptions = {}) {
  const form = useForm({
    defaultValues: {
      cuotas: null,
      referencia: null,
      observaciones: null,
      ...options.defaultValues,
    } as PlanPagoFormValues,
    validators: {
      onSubmit: planPagoSchema,
    },
    onSubmit: async ({ value }) => {
      if (options.onSubmit) {
        await options.onSubmit(value)
      }
    },
  })

  return { form }
}

export type UsePlanPagoFormReturn = ReturnType<typeof usePlanPagoForm>
export type PlanPagoForm = UsePlanPagoFormReturn['form']
